(async () => {
    const { Core } = await importModule('Core');
    const { $classListTemp, $toggleDisplay } = await importModule('Utils');

    const CN_ANIMATE = '!animate';

    customElements.define('cart-counter', class extends Core {

        subscriptions = {
            'cart:update': '_cartUpdateHandler'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'counter' });
            this.subscribe('cart:update', { global: true });
        }

        _cartUpdateHandler(e) {
            if (!e) {
                return;
            }
            
            const meta = e.meta || e.detail?.meta || e.detail?.data?.meta;
            
            if (meta && typeof meta.count !== 'undefined') {
                this.items = meta.count;
                $classListTemp(this, CN_ANIMATE);
            }
        }

        set items(value) {
            this.textContent = value > 99 ? '>99' : value;
            $toggleDisplay(this, !!value);
        }
        
    })
})();